require('./bootstrap');

/** Viator Group Components */

const languageEncoding = require("detect-file-encoding-and-language");
import * as FilePond from 'filepond';

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

FilePond.registerPlugin(FilePondPluginFileValidateType);

FilePond.registerPlugin(FilePondPluginImagePreview);

FilePond.registerPlugin(FilePondPluginFileValidateSize);

function usleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

window.resizeTextArea = function(e) {
    let domElement = e.target;
    let str = domElement.value;
    let cols = domElement.cols;

    let lineCount = 0;
    for(let line in str.split("\n")) {
        lineCount += Math.ceil( line.length / cols ); // Take into account long lines
    }
    domElement.rows = lineCount + 1;
};


document.addEventListener("DOMContentLoaded", function(event) {
    // executes when HTML-Document is loaded and DOM is ready
    FilePond.setOptions({
        server: {
            url: '/upload',
            headers: {
                'X-CSRF-TOKEN': document.head.querySelector("[name=csrf-token]").content
            }
        },
        credits: false,
        allowFileSizeValidation: true,
        maxFileSize: '1MB',
        allowFileTypeValidation: true,
        acceptedFileTypes: 'image/*',
    });
    updateFilepond();
    updateFileFields();
    addScrollToTopListener();
    addScrollToAnchorListener();

    Livewire.on('initFileField',  function() {
        updateFileFields();
    });
});

window.addEventListener('validation:scroll-to', (ev) => {
    ev.stopPropagation();

    window.scrollTo({top: 0, behavior: 'smooth'});

}, false);

window.updateFilepond = function() {
    // filepond=on als selector
    const inputElements = document.querySelectorAll('input[filepond="on"]');

    for (var i in inputElements) {
        let pond = FilePond.create(inputElements[i]);
        let name = inputElements[i].name;
        pond.on('processfile', (error, file) => {
            let serverId = file.serverId;
            livewire.emit('upload', name, serverId);
        });
        pond.on('removefile', (error, file) => {
            livewire.emit('upload', name, '');
        });
    }
}

window.updateFileFields = function() {
    let fileInputs = document.querySelectorAll('input[filepond="off"]');

    for (let i = 0; i < fileInputs.length; i++) {
        fileInputs[i].onchange = () => {
            const reader = new FileReader();
            reader.onload = (e) => {
                Livewire.emit('sendFileInput', e.target.result);
            }

            for (let file of fileInputs[i].files) {
                Livewire.emit('fileSelected', file.name);
                languageEncoding(file).then(fileInfo => {
                    if (fileInfo.encoding) {
                        reader.readAsText(file, fileInfo.encoding);
                    } else {
                        reader.readAsBinaryString(file);
                    }
                });
            }

            fileInputs[i].value = '';
        }
    }
}

window.addScrollToTopListener = function() {
    Livewire.on('scrollToTop', () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behaviour: 'smooth'
        });
    });
}

window.addScrollToAnchorListener = function() {
    Livewire.on('scrollToAnchor', (anchor) => {
        var elementToScrollTo = document.getElementById(anchor);
        if (elementToScrollTo) {
            elementToScrollTo.scrollIntoView();
        }
    });
}

window.copyToClipboard = function (elementId) {
    let inputEl = document.getElementById(elementId);
    const textArea = document.createElement("textarea");
    if (inputEl && inputEl.textContent) {
        textArea.value = inputEl.textContent;

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        window.scrollTo({
            top: 0,
            left: 0
        });
    }
}


/**
 * Clipboard function with IE11 backwards compatibility.
 * @param element
 */
window.copyTextToClipboard = function(element) {
    if(element instanceof Element || element instanceof HTMLDocument) {
        if(!element.hasAttribute('clipboard')) {
            console.warn('The passed element has no clipboard attribute!');
            return;
        }

        const clipboardContent = element.getAttribute('clipboard');
        // Create a temporary element to parse the HTML
        const tempElement = document.createElement('div');
        tempElement.innerHTML = clipboardContent;
        const textContent = tempElement.textContent || tempElement.innerText || '';


        const container = document.createElement('textarea');

        // container.value = element.getAttribute('clipboard');
        container.value = textContent;
        container.setAttribute('readonly', '');
        container.style.cssText = 'position:fixed;pointer-events:none;z-index:-9999;opacity:0;';

        document.body.appendChild(container);

        if (navigator.userAgent && navigator.userAgent.match(/ipad|ipod|iphone/i)) {
            container.contentEditable = true;
            container.readOnly = true;

            const range = document.createRange();

            range.selectNodeContents(container);

            const selection = window.getSelection();

            selection.removeAllRanges();
            selection.addRange(range);

            container.setSelectionRange(0, 999999);
        } else {
            container.select();
        }

        try {
            document.execCommand('copy');
        } catch (e) {
            console.warn(e);
        }

        document.body.removeChild(container);
    }
}
function remove_tags(html) {
    html = html.replace(/<br>/g, "$br$");
    html = html.replace(/(?:\r\n|\r|\n)/g, '$br$');
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    html = tmp.textContent || tmp.innerText;
    html = html.replace(/\$br\$/g, "<br>");
    return html;
}

document.addEventListener('livewire:load', () => {
    window.livewire.on('new-focus', inputName => {
        document.getElementById(inputName).focus();
    })
});
